import { Loader2 } from "lucide-react";
import { warmthLabel } from "../lib/format";

export function PageHeader({ overline, title, subtitle, action }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-8">
      <div>
        {overline && <p className="text-xs font-semibold tracking-[0.2em] uppercase text-muted-foreground mb-2">{overline}</p>}
        <h1 className="font-serif text-3xl sm:text-4xl font-semibold tracking-tight leading-none">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-3 max-w-prose">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function Loader({ label = "Thinking…" }) {
  return (
    <div className="flex items-center gap-3 text-muted-foreground py-10 justify-center" data-testid="loader">
      <Loader2 className="h-5 w-5 animate-spin" strokeWidth={1.5} />
      <span className="font-serif italic text-lg">{label}</span>
    </div>
  );
}

export function PageSkeleton() {
  return (
    <div className="animate-in" data-testid="page-skeleton">
      <div className="shimmer h-3 w-32 rounded-full mb-4" />
      <div className="shimmer h-9 w-72 max-w-full rounded-lg mb-3" />
      <div className="shimmer h-4 w-96 max-w-full rounded-full mb-10" />
      <div className="space-y-4">
        <div className="shimmer h-28 rounded-xl" />
        <div className="shimmer h-28 rounded-xl" />
        <div className="shimmer h-28 rounded-xl" />
      </div>
    </div>
  );
}

export function WarmthBar({ value }) {
  return (
    <div className="flex items-center gap-2.5">
      <div className="h-1.5 w-24 rounded-full bg-muted overflow-hidden">
        <div className="h-full bg-primary/70 rounded-full transition-all duration-700" style={{ width: `${value}%` }} />
      </div>
      <span className="text-xs text-muted-foreground">{warmthLabel(value)}</span>
    </div>
  );
}

export function KolAvatar({ kol, size = 44 }) {
  if (!kol?.photo_url) {
    const initials = (kol?.name || "?").replace(/^Dr\.\s*/i, "").split(" ").map((n) => n[0]).slice(0, 2).join("");
    return (
      <span
        style={{ width: size, height: size, fontSize: size * 0.34 }}
        className="rounded-full bg-primary/10 text-primary grid place-items-center font-semibold shrink-0"
      >
        {initials}
      </span>
    );
  }
  return (
    <img
      src={kol.photo_url}
      alt={kol.name}
      style={{ width: size, height: size }}
      className="rounded-full object-cover bg-muted shrink-0"
    />
  );
}

export function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="text-center py-16 text-muted-foreground" data-testid="empty-state">
      {Icon && <Icon className="h-8 w-8 mx-auto mb-4 opacity-50" strokeWidth={1.25} />}
      <p className="font-serif text-xl text-foreground/70">{title}</p>
      {hint && <p className="text-sm mt-2">{hint}</p>}
    </div>
  );
}
